import { Box, Stack } from '@mui/material'
import { RelativeTimestamp } from 'components/core/time/display'
import { CommentRowContainerStyles } from 'components/pages/task/audit/styles'
import { UserDisplayName } from 'components/pages/user/user-display-name'
import { UserValue } from 'lib/actions/user'
import { TaskAuditView } from 'pbts/c1/api/task/v1/audit'
import React from 'react'

type auditRowContainerProps = {
    user: UserValue
    audit: TaskAuditView
    children: React.ReactNode
    role: string
}

export const CommentRowContainer = ({ children, user, audit, role }: auditRowContainerProps): React.ReactElement => {
    return <Stack direction="column" role={role} sx={{ width: '100%' }}>
        <Box>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Box sx={CommentRowContainerStyles.usernameItem}>
                    <UserDisplayName user={user} includeDetails={false} showTooltip />
                </Box>
                <Box>
                    <RelativeTimestamp variant="dense" date={audit.created} />
                </Box>
            </Stack>
        </Box>
        <Box sx={CommentRowContainerStyles.comment}>
            {children}
        </Box>
    </Stack>
}
